var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsxFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 54,
    viewBox: "0 0 41 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8006 12.2713C33.4384 12.2699 32.1323 11.7282 31.1691 10.765C30.2059 9.80177 29.6641 8.49573 29.6628 7.13352V4.62997e-07H6.7075C5.82678 -0.00032682 4.95458 0.172861 4.14081 0.509671C3.32704 0.84648 2.58759 1.34031 1.96471 1.96295C1.34183 2.5856 0.847725 3.32487 0.510613 4.13851C0.173501 4.95216 -6.08107e-08 5.82424 0 6.70496V47.1241C-6.08106e-08 48.0048 0.173501 48.8769 0.510613 49.6906C0.847725 50.5042 1.34183 51.2435 1.96471 51.8661C2.58759 52.4888 3.32704 52.9826 4.14081 53.3194C4.95458 53.6562 5.82678 53.8294 6.7075 53.8291H34.2649C36.0431 53.8291 37.7486 53.1227 39.006 51.8653C40.2634 50.6078 40.9699 48.9024 40.9699 47.1241V12.2713H34.8006Z",
    fill: "#258750"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_d_3184_2942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9711 12.2713H34.8018C33.4396 12.2699 32.1336 11.7282 31.1704 10.765C30.2071 9.80177 29.6654 8.49573 29.6641 7.13352V0L40.9711 12.2713Z",
    fill: "#258750"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8438 18.5098H6.62448C4.62274 18.5098 3 20.1325 3 22.1342V30.5477C3 32.5494 4.62274 34.1721 6.62448 34.1721H34.8438C36.8455 34.1721 38.4683 32.5494 38.4683 30.5477V22.1342C38.4683 20.1325 36.8455 18.5098 34.8438 18.5098Z",
    fill: "#258750"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69262 28.3086V29.9448H8V28.3086H9.69262Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4043 29.8094L13.9421 27.7239L12.6874 29.8094H10.7616L12.978 26.3602L10.6924 23.1094H12.6851L14.1058 25.1281L15.3328 23.1094H17.2448L15.0583 26.4828L17.3924 29.8094H15.4043Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4043 29.8094L31.9421 27.7239L30.6874 29.8094H28.7616L30.978 26.3602L28.6924 23.1094H30.6851L32.1058 25.1281L33.3328 23.1094H35.2448L33.0583 26.4828L35.3924 29.8094H33.4043Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9629 28.9402C27.7689 29.251 27.4902 29.5001 27.1594 29.6578C26.7582 29.846 26.3183 29.9372 25.8753 29.9241C25.2071 29.9512 24.5486 29.7568 24.0021 29.3712C23.7605 29.1902 23.5627 28.9569 23.4236 28.6889C23.2845 28.4208 23.2076 28.1249 23.1987 27.823H24.9387C24.9502 28.0501 25.0469 28.2645 25.2096 28.4233C25.3714 28.5745 25.5863 28.6556 25.8076 28.649C25.9891 28.6583 26.167 28.5968 26.3041 28.4775C26.3643 28.4191 26.4116 28.3488 26.4431 28.2711C26.4746 28.1934 26.4895 28.11 26.4869 28.0261C26.4891 27.9469 26.4752 27.8681 26.4461 27.7944C26.417 27.7207 26.3733 27.6537 26.3176 27.5974C26.1995 27.4764 26.0583 27.3805 25.9024 27.3152C25.7376 27.2408 25.5074 27.155 25.2253 27.0512C24.8679 26.9334 24.5188 26.7917 24.1804 26.6269C23.9017 26.4828 23.6623 26.2729 23.4831 26.0153C23.2888 25.6992 23.1871 25.335 23.1895 24.964C23.1919 24.5929 23.2983 24.23 23.4966 23.9165C23.7088 23.6151 24.0023 23.3803 24.3429 23.2394C24.7353 23.08 25.1563 23.0032 25.5797 23.0137C26.2208 22.9794 26.8541 23.1684 27.3716 23.5486C27.5894 23.7254 27.7682 23.9454 27.8968 24.1948C28.0254 24.4442 28.1009 24.7175 28.1186 24.9975H26.3515C26.3312 24.7986 26.2455 24.6121 26.1078 24.4671C26.0371 24.4005 25.9536 24.3488 25.8625 24.3151C25.7714 24.2813 25.6745 24.2663 25.5774 24.2708C25.4133 24.2655 25.2529 24.3201 25.126 24.4243C25.0642 24.4812 25.0161 24.5513 24.9852 24.6295C24.9543 24.7077 24.9415 24.7918 24.9477 24.8756C24.9449 25.0265 25.0016 25.1725 25.1057 25.2818C25.218 25.3991 25.3532 25.4921 25.5029 25.5549C25.6631 25.6249 25.8911 25.7151 26.18 25.8235C26.544 25.9408 26.8987 26.0856 27.2407 26.2568C27.5222 26.4075 27.7642 26.6224 27.9471 26.8842C28.1581 27.1998 28.2626 27.5747 28.245 27.9539C28.2445 28.3025 28.1469 28.6441 27.9629 28.9402Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0574 28.5683H22.5395V29.8094H18.1895V23.1094H20.0497L20.0574 28.5683Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3184_2942",
    x: 29.6641,
    y: 0,
    width: 11.3066,
    height: 14.2715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3184_2942"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3184_2942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3184_2942",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxFile);
export default __webpack_public_path__ + "static/media/xlsxFile.16fdb04fd1e964c5d3390d258d1ce035.svg";
export { ForwardRef as ReactComponent };